<template>
	<b-alert v-if="status" v-model="showAlert" variant="danger">
		<strong>{{status.data.status.error.message}}</strong>
		<div v-if="status.data.status.error.errors&&status.data.status.error.errors.message">
			{{status.data.status.error.errors.message}}
		</div>
		<div v-if="showErrors">
			<span v-for="error in showErrors"><strong>{{error.field}} </strong>{{error.message}}</span>
		</div>
	</b-alert>
</template>

<script>

export default {
	name: 'alert',
	props: ['status'],
	data () {
		return {
		}
	},
	mounted(){
	},
	computed: {
		showErrors(){
			var errors = [];
			if (Array.isArray(this.status.data.status.error.errors)){
				this.status.data.status.error.errors.forEach((error)=>{
					if (Array.isArray(error)){
						error.forEach((err)=>{
							errors.push(err);
							// console.log(err);
						})
					} else {
						errors.push(error);
					}

				})
				// return true;
				return errors;
			} else {
				return false;
			}
		},
		showAlert () {
			if (this.status&&this.status.data&&this.status.data.status&&this.status.data.status.error){
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
	}
}
</script>


// WEBPACK FOOTER //
// Alert.vue